/**
 * A cor da etapa na tela, pelo nome que a organização escolheu em
 * Configurações (`green`, `blue`…, a lista fechada de `CORES_DE_ETAPA`).
 *
 * Usada onde a etapa aparece colorida: a régua das etapas em Configurações e o
 * chip da etapa na lista de clientes. Uma tabela só, para a mesma etapa ter a
 * mesma cor em toda tela.
 */
export const HEX_DA_COR: Readonly<Record<string, string>> = {
  green: '#059669',
  turquoise: '#0D9488',
  sky: '#0EA5E9',
  blue: '#2563EB',
  purple: '#7C3AED',
  pink: '#DB2777',
  red: '#DC2626',
  orange: '#EA580C',
  yellow: '#CA8A04',
  gray: '#4B5563',
};

/** O hexadecimal da cor, ou `null` para a que a tela não conhece (cai no tom neutro). */
export function corDaEtapa(cor: string | null | undefined): string | null {
  return cor ? (HEX_DA_COR[cor] ?? null) : null;
}
